import axios from "axios";
import config from "../config";
import { getDoctorToken } from "../utils"

const getAllScheduleTimingListApi = async (params) => {
  const response = await axios({
    url: `${config.api.base_url}schedule-timing/get-all-slots`,
    method: "get",
    params: params,
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${getDoctorToken()}`
    },
  });

  return response;
};

export default getAllScheduleTimingListApi;
